import Wix from './wix-sdk-polyfill';
import getUserPrivacyStatus from './get-user-privacy-status';
import { updateUserPrivacyStatus } from '../actions/update-user-privacy-status';
import { VIEW_MODE_SITE } from '@wix/communities-blog-client-common/dist/src/constants/view-modes';
import { EXPERIMENT_MEMBERS_AREA } from '@wix/communities-blog-experiments';
import { getViewMode } from './wix-sdk-utils';
import { isExperimentEnabled } from '@wix/communities-blog-client-common/dist/src/selectors/experiments-selectors';

const listenToMemberDetailsUpdated = store => {
  const updatePrivacyStatus = () => {
    if (getViewMode() === VIEW_MODE_SITE) {
      getUserPrivacyStatus(privacyStatus => {
        store.dispatch(updateUserPrivacyStatus(privacyStatus));
      });
    }
  };

  if (isExperimentEnabled(store.getState(), EXPERIMENT_MEMBERS_AREA)) {
    Wix.addEventListener(Wix.Events.MEMBER_DETAILS_UPDATED, updatePrivacyStatus);
    updatePrivacyStatus();
  }
};

export default listenToMemberDetailsUpdated;
